
 import { FiSearch } from "react-icons/fi";
 import SearchModal from "./SearchModal";
import PortalModal from "./PortalModal";

 import './NavbarSearchTestPageElementCss/NewSearchBar.css';
 import { useState } from "react";
import useTypewriter from "../../Hooks/useTypewriter";
export default function SearchBar() {
  const animatedText = useTypewriter("Search for tests or checkups", 80);
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="searchBox" onClick={() => setOpen(true)}>
        <FiSearch className="searchIcon" />
         <input  placeholder={animatedText} readOnly /> 
       
      </div>

      {open && <SearchModal onClose={() => setOpen(false)} />}
    </>
  );
}